class NotificationTemplate {
  constructor(data) {
    this.pk = data.pk;
    this.name = data.name;
    this.notification_type = data.notification_type;
    this.subject = data.subject;
    this.content = data.content;
    this.is_visible_to_tenant = data.is_visible_to_tenant;
  }
}
export default NotificationTemplate;